export { default as SiteFooter } from './SiteFooter';
export { LOCALES_ARRAY_PROP_TYPE, LOCALE_INFO_SHAPE_PROP_TYPE, LINKS_DATA_SHAPE_PROP_TYPE, COUNTRIES_ARRAY_PROP_TYPE, HELP_LINKS_PROP_TYPE } from './constants';